import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { YOUTUBE_PLAYER_CONFIG } from '@angular/youtube-player';
import { YoutubePlayerComponent } from '../../../../Components/youtube-player/youtube-player.component';
import { CommonModule } from '@angular/common';
import { MEDIA_CENTER_DATA } from '../mediaCenter.data';
import { BaseComponent } from '../../../base.component';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { IList } from '../../../../Models/list.model';
import { IResponse } from '../../../../Models/response.model';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';
import { DOMAIN_TYPE, SCHEMA_TYPE, BAC_PAGES } from '../../../../constants';

@AutoUnsubscribe()
@Component({
  selector: 'app-radio',
  standalone: true,
  imports: [PageheaderComponent, YoutubePlayerComponent, CommonModule],
  providers: [
    SchoolApiService,
    {
      provide: YOUTUBE_PLAYER_CONFIG,
      useValue: {
        disablePlaceholder: true,
      },
    },
  ],
  templateUrl: './radio.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'media_center', path: '/mediacenter' },
    children: [{ title: 'radio', path: null }],
  };

  // public RADIO_DATA = MEDIA_CENTER_DATA.radio;
  public RADIO_DATA: any;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.MEDIA;
    this.articleType = BAC_PAGES.MEDIA.RADIO;

    this.onPaginateEvent();
  }

  onPaginateEvent() {
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: 0,
        limit: 10,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.RADIO_DATA = data.payload?.list.map((record) => {
            return {
              title: record.title,
              videoUrl: this.splitYoutubeIdFromURL(
                (record.youtubeUrls || [])[0]
              ),
            };
          });
          this.cdr.detectChanges();
        }
      });
  }
}
